import { CategoryChip } from '@/hooks/api/use-categories'
import { create } from 'zustand'

// Start Type
type StartType = 'ตามหางานแข่ง' | 'ประกาศงานแข่ง' | 'skip'

// Referral Type
type ReferralType = string

// Custom Objective Interface
interface CustomObjective {
  type: 'อื่นๆ'
  value: string
}

// Objective Type
type ObjectiveType =
  | 'COMPETITION'
  | 'TEACHER'
  | 'PARENT'
  | 'skip'
  | CustomObjective

// Social Media Account Type
type SocialMediaAccount = {
  name: string
  platform: string
}

// Information Type
export type EducationalLevel =
  | 'PRIMARY'
  | 'MIDDLE'
  | 'HIGH'
  | 'BACHELOR'
  | 'MASTER'
  | 'PHD'
  | 'ANY'
  | 'skip'
  | 'primary-done'
  | 'middle-done'
  | 'high-done'
  | 'bachelor-done'
  | 'masters-done'
  | 'phd-done'

export type EducationalLevelDTO =
  | 'PRIMARY'
  | 'MIDDLE'
  | 'HIGH'
  | 'BACHELOR'
  | 'MASTER'
  | 'PHD'
  | 'ANY'

export type Information = {
  dateOfBirth: string
  currentEducationLevel: EducationalLevel
  placeOfStudy: string
  year: string
  province: string
  phone: string
  lineID: string
  socialMedia: SocialMediaAccount[]
  shirtSize: string
}

// Page Data Type
type PageData = {
  pageRegister: {
    name_en: string
    surname_en: string
    username: string
    password?: string
    google_id?: string | null
    email_verification_token?: string | null
    turnstile_token?: string | null
  } | null
  pageZero: { start: StartType } | null
  pageOne: { objective: ObjectiveType } | null
  pageTwo: { categories: CategoryChip[] } | null
  pageThree: { information: Information } | null
  pageFour: { referral: ReferralType } | null
  pageFive: { completed: boolean } | null
  pageSix: { objectOther: CustomObjective } | null
  email?: string
  hasVerifiedEmail: boolean
  setHasVerifiedEmail: (hasVerifiedEmail: boolean) => void
}

// Onboarding State Interface
interface OnboardingState extends PageData {
  currentStep: number
  setData: <K extends keyof PageData>(
    step: K,
    data: NonNullable<PageData[K]>
  ) => void
  setStep: (step: number) => void
  nextStep: () => void
  previousStep: () => void
  resetForm: () => void
}

// Create Zustand Store
export const useOnboardingStore = create<OnboardingState>((set) => ({
  currentStep: 0,
  pageRegister: null,
  pageZero: null,
  pageOne: null,
  pageTwo: null,
  pageThree: null,
  pageFour: null,
  pageFive: null,
  pageSix: null,
  hasVerifiedEmail: false,
  email: '',
  setHasVerifiedEmail: (hasVerifiedEmail) => set(() => ({ hasVerifiedEmail })),

  setData: (step, data) => set((state) => ({ ...state, [step]: data })),

  nextStep: () => set((state) => ({ currentStep: state.currentStep + 1 })),

  setStep: (step) => set(() => ({ currentStep: step })),

  previousStep: () =>
    set((state) => ({ currentStep: Math.max(0, state.currentStep - 1) })),

  resetForm: () => {
    set(() => ({
      currentStep: 0,
      pageRegister: null,
      pageZero: null,
      pageOne: null,
      pageTwo: null,
      pageThree: null,
      pageFour: null,
      pageFive: null,
      pageSix: null,
    }))
  },
}))
